import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import ThemeToggle from "./ThemeToggle";

const NAV = [
    { to: "/benefits/ignite-health", label: "Ignite Health" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
];

export default function Header() {
    const [open, setOpen] = useState(false);

    return (
        <header
            className="sticky top-0 z-40 bg-background/85 backdrop-blur border-b border-border"
            data-testid="site-header"
        >
            <div className="container-x flex items-center justify-between h-16 md:h-20">
                <Link to="/" data-testid="header-logo-link" onClick={() => setOpen(false)}>
                    <Logo />
                </Link>

                <nav className="hidden lg:flex items-center gap-9" aria-label="Primary">
                    {NAV.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className={({ isActive }) =>
                                `text-sm tracking-wide transition-colors ${
                                    isActive
                                        ? "text-foreground"
                                        : "text-navy hover:text-brand"
                                }`
                            }
                        >
                            {n.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <ThemeToggle />
                    <Link
                        to="/benefits/ignite-health#video"
                        data-testid="header-cta-proposal"
                        className="hidden md:inline-flex items-center bg-brand text-brand-foreground hover:bg-brand-hover px-5 py-2.5 rounded-sm text-sm font-medium tracking-wide transition-colors"
                    >
                        Watch the Overview
                    </Link>
                    <button
                        type="button"
                        onClick={() => setOpen((v) => !v)}
                        className="lg:hidden inline-flex items-center justify-center h-9 w-9 rounded-sm border border-border"
                        aria-label="Toggle menu"
                        aria-expanded={open}
                        data-testid="mobile-menu-toggle"
                    >
                        {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
                    </button>
                </div>
            </div>

            {open && (
                <div className="lg:hidden border-t border-border bg-background" data-testid="mobile-nav">
                    <div className="container-x py-6 flex flex-col gap-5">
                        {NAV.map((n) => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className="text-base text-foreground"
                            >
                                {n.label}
                            </NavLink>
                        ))}
                        <Link
                            to="/benefits/ignite-health#video"
                            onClick={() => setOpen(false)}
                            data-testid="mobile-cta-proposal"
                            className="inline-flex items-center justify-center bg-brand text-brand-foreground px-5 py-3 rounded-sm text-sm font-medium"
                        >
                            Watch the Overview
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
}
